<template>
  <div>
    <translate tag="h3"> Tax </translate>
    <p v-if="cityTax">
      {{ cityTax }}
    </p>
    <div v-if="exclusiveTaxes.length > 0">
      <translate
        v-for="tax in exclusiveTaxes"
        :key="tax.text"
        tag="div"
        :tt="{ taxText: tax.text, taxRate: tax.rate }"
      >
        {taxText} (exclusive) {taxRate, puNumber, style:percent
        minimumFractionDigits:3}
      </translate>
    </div>
    <campsite-arrival-tax
      v-for="(tax, index) in arrivalTaxes"
      :key="index"
      :tax="tax"
    />
  </div>
</template>

<script lang="ts">
import type {
  CampsiteArrivalTax as ArrivalTax,
  CampsiteCityTax,
  CampsiteTax,
} from '../../../campsite-details/types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CampsiteTaxTerms extends Vue {
  @Prop({ required: true })
  cityTax: CampsiteCityTax

  @Prop({ required: true })
  exclusiveTaxes: CampsiteTax[]

  @Prop({ required: true })
  arrivalTaxes: ArrivalTax[]
}

export default toNative(CampsiteTaxTerms)
</script>
